import React from 'react';
import type { BuiltResume } from '../../../resume-engine/types';
import { ResumeSection } from './ResumeSection';

interface Props {
  education: BuiltResume['education'];
}

export function EducationSection({ education }: Props) {
  if (!education.length) return null;

  return (
    <ResumeSection title="Education">
      {education.map((edu) => (
        <div key={edu.institution} className="resume-education-item">
          <h3 className="resume-education-degree">
            {edu.degree} in {edu.field}
          </h3>
          <p className="resume-education-meta">
            {edu.institution} · {edu.duration} · GPA: {edu.grade}
          </p>
        </div>
      ))}
    </ResumeSection>
  );
}
